'use client';

import { useMutation } from '@tanstack/react-query';
import { startTrialAction } from './actions';
import type { StartTrialRequest, StartTrialResponse } from './types';

/**
 * Starts the firm's trial by creating a Stripe checkout session
 * (POST /account/billing/start-trial). The caller supplies the Stripe
 * return URLs and, on success, redirects the browser to `checkoutUrl`.
 *
 * No cache invalidation is wired here — success navigates the whole page
 * away to Stripe; the gate re-reads the firm status on return.
 */
export function useStartTrial() {
  return useMutation<StartTrialResponse, Error, StartTrialRequest>({
    mutationFn: async (request) => {
      const result = await startTrialAction(request);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to start trial');
      }
      return result.data;
    }
  });
}
